import React from "react";

interface InfoIconProps {
  className?: string;
  size?: number;
}

export const InfoIcon = ({ className = "", size }: InfoIconProps) => {
  const sizeValue = size || 16;

  return (
    <svg
      width={sizeValue}
      height={sizeValue}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="8" cy="8" r="8" fill="#EDEDED" />
      <path
        d="M7.8316 4.30762C8.05806 4.30762 8.24514 4.38146 8.39283 4.52916C8.54052 4.67685 8.61437 4.86392 8.61437 5.09039C8.61437 5.31685 8.54052 5.50392 8.39283 5.65162C8.24514 5.79931 8.05806 5.87316 7.8316 5.87316C7.60514 5.87316 7.41806 5.79931 7.27037 5.65162C7.12267 5.50392 7.04883 5.31685 7.04883 5.09039C7.04883 4.86392 7.12267 4.67685 7.27037 4.52916C7.41806 4.38146 7.60514 4.30762 7.8316 4.30762ZM7.22606 7.21715H8.43714V12.2879H7.22606V7.21715Z"
        fill="#5E5E5E"
      />
    </svg>
  );
};
